import { AccessFunctionFieldUpdateCallback, AccessFunctionFormSection } from 'data/accessFunction/accessFunction.types';
import { openNetworkCreatePopup } from 'data/network/network.actions';
import { getNetworkCreatedId } from 'data/network/network.selectors';
import { Network } from 'data/network/network.types';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FieldUpdateHandlerParam } from 'shared/form';

// eslint-disable-next-line import/prefer-default-export
export function useAccessFunctionFieldCreateNewNetwork(
  handleFieldUpdate: AccessFunctionFieldUpdateCallback,
): [AccessFunctionFieldUpdateCallback] {
  const idCreated = useSelector(getNetworkCreatedId);
  const dispatch = useDispatch();
  const paramRef = useRef<FieldUpdateHandlerParam>();
  const formSectionRef = useRef<AccessFunctionFormSection>();
  const interfaceIdRef = useRef<string | number>();

  useEffect(() => {
    if (idCreated == null || paramRef.current == null || formSectionRef.current == null) {
      return;
    }

    const param = paramRef.current;
    if (param == null) {
      return;
    }

    paramRef.current = undefined;

    param.value = idCreated;
    // The value label may have been changed in the create dialog, so removing it to avoid confusion
    param.valueLabel = null;

    handleFieldUpdate(param, formSectionRef.current, interfaceIdRef.current);

  }, [idCreated]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFieldCreateNew: AccessFunctionFieldUpdateCallback = (param, formSection, interfaceId) => {
    if (
      formSection !== 'provisioningInterfaces'
      && formSection !== 'dataInterfaces'
      && formSection !== 'contentInterfaces'
      && formSection !== 'monitoringCenters'
      && formSection !== 'usnbdAgencies'
      && formSection !== 'usnbdCallDataChannels'
    ) {
      return;
    }

    const network: Network = {
      id: '',
      networkId: param.valueLabel,
      ownIPAddress: '',
      portNumberRange: '1',
      startPortNumber: '0',
    };

    dispatch(openNetworkCreatePopup(network));

    paramRef.current = param;
    formSectionRef.current = formSection;
    interfaceIdRef.current = interfaceId;
  };

  return [handleFieldCreateNew];
}
